import { Button } from '@purpurds/purpur';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PageNotFoundStateIcon } from 'assets/404-page-state.svg';
import { ReactComponent as ErrorStateIcon } from 'assets/error-state.svg';
import { ReactComponent as NoResultsIcon } from 'assets/no-results.svg';
import './ErrorState.scss';
import Heading from 'components/voca/heading/Heading';
import Paragraph from 'components/voca/paragraph/Paragraph';

type Props = {
  errorMessage?: string;
  type: 'fetchError' | 'noResults' | 'pageNotFound';
  enableRefreshButton?: boolean;
  children?: React.ReactNode;
};

const getIcon = (type: Props['type']) => {
  switch (type) {
    case 'fetchError':
      return <ErrorStateIcon />;
    case 'noResults':
      return <NoResultsIcon />;
    case 'pageNotFound':
      return <PageNotFoundStateIcon />;
  }
};

const ErrorState = ({ errorMessage, type, enableRefreshButton = false, children }: Props) => {
  const { t } = useTranslation();
  const defaultMessage =
    type === 'fetchError'
      ? t('error_state.fetch_error_message')
      : t('error_state.search_no_results');
  const message = errorMessage ? errorMessage : defaultMessage;

  return (
    <div className={'error-state__wrapper'}>
      {getIcon(type)}

      {type !== 'noResults' ? (
        <Paragraph>{message}</Paragraph>
      ) : (
        <Heading tag="h2">{message}</Heading>
      )}

      {children && children}

      {enableRefreshButton && (
        <Button variant="primary" size="md" onClick={() => window.location.reload()}>
          {t('error_state.refresh_page')}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
